import { Component, OnInit, Input, KeyValueDiffer, KeyValueDiffers, ChangeDetectionStrategy, OnChanges, SimpleChanges } from '@angular/core';
import { CONFIG } from '../../constants/constants';
import { ItemControlService } from '../../../app/services/item/item-control.service';

@Component({
  selector: 'app-reproductoraudio',
  templateUrl: './reproductor-audio.component.html',
  styleUrls: ['./reproductor-audio.component.css']
})

export class ReproductorAudioComponent implements OnInit, OnChanges {

  @Input() data: any;

  /** Arreglo con información de los audios */
  public audios: any[] = [];

  /** Coponente de audio html5*/
  private elementoAudio: any;

  /**Guarda el valor del audio actual */
  private audioActual: string;

  /** Guarda el valor de la velocidad seleccionada  */
  private velocidadAudio: number;

  private itemId: string;

  /** Arreglo con las velocidades de reproducción */
  public velocidades: any = [
    0.50, 0.75, 1.00, 1.25, 1.50
  ];

  /** Arreglo para la creación de botones */
  private opcionesRespuestas: any = [
    'EN', 'A', 'B', 'C', 'D'
  ];

  differ: KeyValueDiffer<string, any>;

  constructor(private differs: KeyValueDiffers, public itemControlService: ItemControlService) {
    this.differ = this.differs.find({}).create();


  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data && changes.data.currentValue) {
      this.cambioDeItem();
      if (this.data.type != 'ing_p4' && this.data.type != 'ing_p2' && this.data.type != 'ing_p7' && this.data.type != 'grid') {
        this.armadoArregloAudios(this.data);
      } else {
        this.audios = Object.assign([], []);
      }
    }
  }

  cambioDeItem() {
    if (this.elementoAudio) {
      this.elementoAudio.pause();
      this.elementoAudio.currentTime = 0;
      this.elementoAudio.src = '';
      this.elementoAudio.load();
      this.audios = Object.assign([], []);
    }
  }

  ngOnInit() {
    this.velocidadAudio = 1;
    this.elementoAudio = document.getElementById("audioPlexi");
    this.itemControlService.subItem.subscribe(subItem => {
      (subItem.id) && this.armadoArregloAudiosP2P4P7(subItem);
    })
  }

  armadoArregloAudiosP2P4P7(subItem: any) {

    this.cambioDeItem();
    let opcionesRespuestas = ['EN', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K'];
    this.audios.length = 0;


    if (this.esSubItemEjemplo(subItem)) {
      opcionesRespuestas = opcionesRespuestas.slice(0, subItem.cantidadRespuestas + 1);
      opcionesRespuestas.forEach(element => {
        this.audios.push(
          {
            name: element,
            src: CONFIG.RUTA_BASE + `${this.data.itemNumero}/${subItem.id}-${element}.mp3`
          }
        );
      });
      this.audios = Object.assign([], this.audios);
      return;
    }

    if (this.esSubItemNormal(subItem)) {
      opcionesRespuestas = opcionesRespuestas.slice(0, subItem.cantidadRespuestas + 1);
      opcionesRespuestas.forEach(element => {
        this.audios.push(
          {
            name: element,
            src: CONFIG.RUTA_BASE + `${subItem.id}/${subItem.id}-${element}.mp3`
          }
        );
      });
      this.audios = Object.assign([], this.audios);
      return;
    }

    if (this.esSubItemEnunciado(subItem)) {
      this.audios.push(
        {
          name: opcionesRespuestas[0],
          src: CONFIG.RUTA_BASE + `${subItem.id}/${subItem.id}-${opcionesRespuestas[0]}.mp3`
        }
      );
      this.audios = Object.assign([], this.audios);
      return;
    }
  }

  esSubItemEjemplo = (subItem) => subItem.id == 'Ejemplo' || subItem.id == 'ejemplo';
  esSubItemNormal = (subItem) => subItem && subItem.id && subItem.cantidadRespuestas;
  esSubItemEnunciado = (subItem) => subItem && subItem.id && subItem.cantidadRespuestas === null;
  esItemSimple = (item) => item.type == 'single' && item.contentDecrypted;
  
  /** Selecciona la pista dedata audio según valor */
  public seleccionarAudio(event, valor: string) {

    this.itemId = this.data.itemId;
    this.audioActual = valor;
    this.removerEstilos('btn-respuestas');
    event.target.classList.add('btn-select');
    this.elementoAudio.pause();
    this.elementoAudio.preload = 'auto';
    this.elementoAudio.src = this.audioActual;
    this.elementoAudio.load();
    this.elementoAudio.playbackRate = this.velocidadAudio;
    this.elementoAudio.play();

    this.elementoAudio.onerror = function () {
      console.log("error en la carga del audio");
    };

  }

  private armadoArregloAudios(data: any) {

    if (this.esItemSimple(data)) {
      this.opcionesRespuestas = ['EN', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'Ñ', 'O'];
      const html = new DOMParser().parseFromString(data.contentDecrypted, "text/html");
      const opcionesDeRespuestaItem = html.getElementsByTagName('input').length;
      this.opcionesRespuestas = this.opcionesRespuestas.slice(0, opcionesDeRespuestaItem + 1);
    }

    this.audios.length = 0;

    var recursos = data.recursosItem.substring(1, data.recursosItem.length - 1).split(',');

    if (recursos[0].search("C_") > 0) {
      var temp = {
        name: 'Contexto',
        src: `${CONFIG.RUTA_BASE}${recursos[0].replace(/"/g, '')}/${recursos[0].replace(/"/g, '')}.mp3`
      }
      this.audios.unshift(temp);
    }

    if (this.data.itemNumero != null) {
      this.opcionesRespuestas.forEach(element => {
        this.audios.push(
          {
            name: element,
            src: CONFIG.RUTA_BASE + `${this.data.itemNumero}/${this.data.itemNumero}-${element}.mp3`
          }
        );
      });
    }

    if (data && data.type == 'open') {
      this.audios = this.audios.slice(0, 1);
    }

    if (this.audioActual != null) {
      if (this.itemId == this.data.itemId) {
        this.elementoAudio.play();
      }
    }
    this.audios = Object.assign([], this.audios);
    this.opcionesRespuestas = ['EN', 'A', 'B', 'C', 'D'];
    //console.log(this.audios);
  }

  /** Selecciona la velocidad de reproducción de audio */
  public seleccionarVelocidad(event, valor: number) {

    this.removerEstilos('btn-velocidad');
    event.target.classList.add('btn-select');
    this.velocidadAudio = valor;
    // this.elementoAudio.pause();
    this.elementoAudio.playbackRate = valor;


  }

  /** Elimina clase btn-select según ClassName */
  private removerEstilos(nombreClase: string) {
    var data = document.getElementsByClassName(nombreClase);
    for (let i = 0; i < data.length; i++) {
      data[i].classList.remove("btn-select");
    }
  }
}